export default __webpack_public_path__ + "static/media/loading-blockchain.cd41a7db.gif";